import React, { useState, useEffect, useCallback } from "react";
import camuflado from "../../../camuflado.jpg";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { AndroidOutlined, AppleOutlined } from "@ant-design/icons";
import {
  Col,
  Card,
  Row,
  Typography,
  Input,
  Form,
  Button,
  notification,
  Skeleton,
} from "antd";
import { format } from "date-fns";
import GraficoAnual from "../../graficos/GraficoAnual";
import GraficoTreino from "../../graficos/GraficoTreino";
import GraficoComp from "../../graficos/GraficoComp";
import { useHistory, useParams } from "react-router-dom";
import axiosInstance from "../../../axiosInterceptor";

const { Text } = Typography;

const EditarClube = () => {
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const { idClubeEditar } = useParams();
  const [loading, setLoading] = useState(false);
  const [cnpj, setCnpj] = useState("");
  const [nome, setNome] = useState("");
  const [endereco, setEndereco] = useState("");
  const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const options = {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + accessToken,
          },
        };

        const response = await axiosInstance.get(
          "https://app-photo-api-java.herokuapp.com/v1/clube/" + idClubeEditar,
          options
        );

        // setRegistros(response.data);
        //setRefreshing(false);
        // Preencha os campos com os dados obtidos da API
        setNome(response.data.nome);
        setEndereco(response.data.endereco);
        setCnpj(response.data.cnpj);
      } catch (error) {
        console.error("Erro ao carregar os dados:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [idClubeEditar, accessToken]);

  const onFinish = (data) => {
    data.idUsuario = idUser;

    setLoading(true);
    const options = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    axiosInstance
      .put(
        `https://app-photo-api-java.herokuapp.com/v1/clube/${idClubeEditar}`,
        data,
        options
      )
      .then((response) => {
        setLoading(false);
        window.alert("Clube salvo com sucesso!");

        setTimeout(() => {
          history.push("/4");
        }, 300);
      })
      .catch((error) => {
        console.error("Erro na requisição:", error);
        setLoading(false);
        window.alert("Falha na edição");
        setTimeout(() => {}, 300);
      })
      .finally(() => {});
  };
  return (
    <Container>
      <Row
        gutter={16}
        style={{
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Col xs={20} lg={16}>
          <Card style={{ width: "100%" }}>
            <Row
              gutter={16}
              style={{
                justifyContent: "center",
              }}
            >
              {loading ? (
                <Skeleton active />
              ) : (
                <Form onFinish={onFinish}>
                  <Form.Item
                    label="CNPJ"
                    initialValue={cnpj}
                    name="cnpj"
                    rules={[
                      {
                        required: true,
                        message: "Por favor, insira o CNPJ!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="Nome"
                    name="nome"
                    initialValue={nome}
                    rules={[
                      {
                        required: true,
                        message: "Por favor, insira o nome do clube!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="Endereço"
                    name="endereco"
                    initialValue={endereco}
                    rules={[
                      {
                        required: true,
                        message: "Por favor, insira o endereço!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Salvar
                    </Button>
                  </Form.Item>
                </Form>
              )}
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

const Container = styled.div`
  justify-content: center;
  display: flex;
  align-items: center;
  background-color: #484848;
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-image: url(${camuflado});
`;

export default EditarClube;
